import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { RenameObjectInput } from "../../../../common/RenameObjectInput";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppButton } from "../../../../shared/components/AppButton";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { ClearIcon } from "../../../../shared/icons/ClearIcon";
import { deleteDialogThreadAction } from "../../redux/actions";
import styles from "./styles.module.css";
import { DialogSelections } from "./DialogSelections";
import { selectIsMessageLoading } from "../../redux/selectors";

export const DialogsHeader = () => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("dialogs");
  const isMessageLoading = useAppSelector(selectIsMessageLoading);
  const { t } = useTranslation();

  const handleClearChat = () => {
    if (!selectedObject?.value?.dialog_object) return;
    const thread_ref = selectedObject?.value?.dialog_object?.thread_ref;
    dispatch(deleteDialogThreadAction(thread_ref as string));
  };

  return (
    <AppUnderlinedTitle
      leftContent={
        <div className={styles["header-container"]}>
          <RenameObjectInput service={"dialogs"} inputType={"input"} />
          <DialogSelections />
        </div>
      }
      leftContentSize={"max"}
      className={styles.title}
    >
      <AppButton
        className={classNames(styles.clear, {
          [styles.disabled]: isMessageLoading,
        })}
        small
        onClick={handleClearChat}
        buttonType={"text"}
        icon={<ClearIcon />}
        disabled={
          isMessageLoading || !selectedObject?.value?.dialog_object?.thread_ref
        }
      >
        {t("common.clear_btn")}
      </AppButton>
    </AppUnderlinedTitle>
  );
};
